module.exports = __webpack_public_path__ + "img/18.018ab074.jpg";